<template>
  <b-card v-if="points && points.length" title="Динамика по неделям">
    <vue-apex-charts type="line" height="350" :options="chartOptions" :series="series" />
  </b-card>
  <b-card v-else>
    <div class="text-center text-muted py-4">Нет данных за выбранный период</div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'
import { formatRub, rollingMedian } from '@/views/finance/utils'

export default {
  components: { BCard, VueApexCharts },
  props: {
    points: { type: Array, default: () => [] },
  },
  setup(props) {
    const medianWindow = computed(() => {
      const n = props.points.length
      if (n < 3) return 0
      let w = Math.round(n / 4)
      if (w < 3) w = 3
      if (w > n) w = n
      if (w % 2 === 0) {
        if (w + 1 <= n) w += 1
        else w -= 1
      }
      return w
    })

    const series = computed(() => {
      const base = [
        { name: 'Выручка', data: props.points.map(p => p.revenue) },
        { name: 'Расходы', data: props.points.map(p => p.expenses) },
        { name: 'Прибыль', data: props.points.map(p => p.profit) },
      ]
      if (medianWindow.value > 0) {
        base.push({
          name: `Медиана прибыли (скольз., ${medianWindow.value} нед.)`,
          data: rollingMedian(props.points.map(p => p.profit), medianWindow.value),
        })
      }
      return base
    })

    const chartOptions = computed(() => {
      const hasMedian = medianWindow.value > 0
      const colors = [$themeColors.success, $themeColors.danger, $themeColors.primary]
      const widths = [2, 2, 2]
      const dashes = [0, 0, 0]
      if (hasMedian) {
        colors.push($themeColors.warning)
        widths.push(2)
        dashes.push(6)
      }
      return {
        chart: { toolbar: { show: true }, zoom: { enabled: true } },
        colors,
        stroke: { curve: 'smooth', width: widths, dashArray: dashes },
        markers: { size: 4 },
        xaxis: {
          categories: props.points.map(p => p.label),
          labels: { rotate: -30, style: { fontSize: '11px' } },
        },
        yaxis: {
          labels: { formatter: val => formatRub(val) },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: val => formatRub(val) },
        },
        legend: { position: 'top' },
      }
    })

    return { series, chartOptions }
  },
}
</script>
